import {lowerCase} from 'lodash'
import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getPricingByCurrency} from 'utils/getPricingByCurrency'

type Props = {
  option: Ventrata.Option
  currency: Basic.Currency
  calendarDay: Ventrata.CalendarDay | null
}

export const CostFromPerUnit = ({option, currency, calendarDay}: Props) => (
  <div className="text-end">
    {option.units
      .map((unit) => {
        const pricingSource = calendarDay
          ? calendarDay.unitPricingFrom?.find((p) => p.unitId === unit.id)
          : unit.pricingFrom
        return `${formatMoney(getPricingByCurrency(pricingSource, currency)?.retail, currency)}/${lowerCase(
          unit.title
        )}`
      })
      .join(', ')}
  </div>
)
